import { GetStaticPropsResult } from "next";
import { NextSeo } from "next-seo";
import Image from "next/image";
import React, { useEffect, useState } from "react";
import Button from "src/components/widgets/button/Button";
import SplitBlock from "src/components/widgets/splitBlock/SplitBlock";
import { Colours, styled } from "src/styles";
import Banner from "../../components/widgets/bannerNew/Banner";
import Section from "../../components/widgets/section/Section";
import sanity from "../../sanity/sanity";
import IEmployee from "../../sanity/types/Employee";
import styles from "./About.module.scss";
import { IoClose } from "react-icons/io5";

export type AboutProps = {
    employees: IEmployee[];
};

// const reasons = [
//     "We are proud to be a family run swim school for over 30 years.",
//     "We are passionate about getting the best results possible for your child.",
//     "We feel both technique and stamina go hand in hand to prepare students for NZ water conditions and therefore make sure students are extended.",
//     "We place water safety very highly in our swim school curriculum.",
//     "We value and strive for continuity of instructors with our swimmers.",
//     "Our office prides itself on being helpful and friendly.",
//     "We are open to your feedback and will endeavour to address any issues that may arise.",
//     "Staff are hand picked and meticulously trained and do not take their own classes unless they met the required criteria.",
// ];

//https://cdn.sanity.io/images/4f1fpc2v/production/5a395fd9cec74f043343b92d62882601732cae83-1500x1001.jpg
export default function About(props: AboutProps) {
    const { employees } = props;

    return (
        <>
            <NextSeo
                title={"About"}
                openGraph={{
                    images: [
                        {
                            url: "https://cdn.sanity.io/images/4f1fpc2v/production/d1d8c5957756deb9204d7eb9696fc2c48d6e71fe-1500x1001.jp",
                        },
                    ],
                }}
            />
            <Banner
                image={
                    "https://cdn.sanity.io/images/4f1fpc2v/production/d1d8c5957756deb9204d7eb9696fc2c48d6e71fe-1500x1001.jpg?rect=200,0,800,800"
                }
                title={"Dedicated to providing top quality tuition in a safe and fun environment."}
                actions={<Button>Contact Us</Button>}
            />
            <Section>
                <Section.LeftBackground />
                <SplitBlock
                    left={(
                        <SplitBlock.Image>
                            <Image
                                src={"https://cdn.sanity.io/images/4f1fpc2v/production/d353871663ad65a3f200fcd5aa0e96934598e8f7-1500x1001.jpg"}
                                layout={"fill"} objectFit={"cover"} />
                        </SplitBlock.Image>
                    )}
                    right={(
                        <SplitBlock.Body>
                            <SplitBlock.Header>About us</SplitBlock.Header>
                            <SplitBlock.Paragraph>
                                Ross, Jennimay, our son Jordan and our amazing instructors are dedicated to providing the
                                best quality
                                tuition in a safe and fun environment.{" "}
                            </SplitBlock.Paragraph>
                            <SplitBlock.Paragraph>
                                Our focus is to ensure we provide a well-balanced program that allows all students to
                                have the
                                opportunity to build water confidence, a love of the water and to be extended in both
                                technique and
                                stamina.
                            </SplitBlock.Paragraph>
                            <SplitBlock.Paragraph>
                                We are proud to have so many parents recommending our swim school to their friends and
                                families and to
                                have the pleasure of teaching the next generations over the past 31 years
                            </SplitBlock.Paragraph>
                        </SplitBlock.Body>
                    )}
                />
            </Section>

            {/* <Section>
                <div className={styles.splitBlock}>
                    <div className={styles.splitBlockItem}>
                        <div className={styles.splitBlockItemInner}>
                            <h3>About us</h3>
                            <p></p>
                            <p>Our focus is to ensure we provide a well-balanced program that allows all students to
                                have the opportunity to build water confidence, a love of the water and to be extended
                                in both technique and stamina.</p>
                            <p>We are proud to have so many parents recommending our swim school to their friends and
                                families and to have the pleasure of teaching the next generations over the past 31
                                years.</p>
                        </div>
                    </div>
                    <div className={styles.splitBlockItem}>
                        <div className={styles.image}>
                            <Image
                                src={"/images/classes/preschool_float_glide/20.jpg"}
                                // src={"/images/classes/supa_squad/102.jpg"}
                                layout={"fill"}
                                objectPosition={"center"}
                                objectFit={"cover"} />
                        </div>
                    </div>
                </div>
            </Section> */}
            <Section>
                <Header id={"team"}>Our team</Header>
                <Employees>
                    {employees.map((employee) => {
                        return (
                            <EmployeeItem key={employee._key} employee={employee} />
                        );
                    })}
                </Employees>
            </Section>
        </>
    );
}

const EmployeeItem = (props: { employee: IEmployee }) => {
    const { employee } = props;
    const { _key, name, role, image, blurb } = employee;
    const sanityImage = sanity.urlFor(image);
    const [isOpen, setIsOpen] = useState(false);

    const onPress = () => {
        setIsOpen((prevState) => !prevState);
    };

    useEffect(() => {

        if (!isOpen) {
            document.body.style.overflow = "auto";
            return;
        }

        document.body.style.overflow = "hidden";
    }, [isOpen]);

    return (
        <>
            <Employee key={_key} onClick={isOpen ? undefined : onPress}>
                <EmployeeImage className={styles.image} style={{ backgroundImage: `url(${sanityImage.url()}?webp)` }} />
                <h4>{name}</h4>
                <p>{role}</p>
                {isOpen && (
                    <Background onClick={(e) => {
                        e.stopPropagation();
                        onPress();
                    }}>
                        <EmployeeBlurb onClick={(e) => e.stopPropagation()}>
                            <div>
                                <EmployeeImage className={styles.image} style={{ backgroundImage: `url(${sanityImage.url()}?webp)` }} />
                                <h4>{name}</h4>
                                <p><strong>{role}</strong></p>
                                <br/>
                                <p>{blurb}</p>
                            </div>

                            <CloseButton onClick={(e) => {
                                e.stopPropagation();
                                onPress();
                            }}>
                                <Close />
                            </CloseButton>
                        </EmployeeBlurb>
                    </Background>
                )}
            </Employee>
        </>
    );
};

const Header = styled.h2`
    font-size: 48px;
    text-align: center;
    margin-bottom: 72px;

    &:before {
        display: block;
        content: " ";
        margin-top: -100px;
        height: 100px;
        visibility: hidden;
    }
`;

const Employees = styled.div`
    justify-content: center;
    flex-wrap: wrap;
    padding: 0 36px;
    display: grid;
    grid-column-gap: 90px;
    grid-template-columns: repeat(auto-fill, 234px);
`;

const Employee = styled.div`
    display: inline-flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    padding: 18px;
    cursor: pointer;
    border-radius: 18px;

    h4 {
        padding-top: 10px;
        margin-bottom: 0;
        font-size: 22px;
    }

    p {
        margin-top: 0;
    }

    &:hover {
        background: ${Colours.GREY};
    }
`;

const EmployeeImage = styled.div`
    width: 135px;
    height: 135px;
    max-width: 100%;
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    border-radius: 50%;
`;

const Background = styled.div`
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    bottom: 0;
    background: #00000080;
    z-index: 14000;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 36px;
`;

const EmployeeBlurb = styled.div`
    position: relative;
    border-radius: 9px;
    background: ${Colours.GREY};
    z-index: 15000;
    display: flex;
    align-items: center;
    flex-direction: column;
    cursor: default;
    max-width: 650px;
    
    top: 18px;
    bottom: 18px;
    max-height: 80%;

    p {
        margin: 0;
    }
    
    > div {
        overflow-y: auto;
        padding: 36px 24px;
        text-align: center;
        
        > div {
            display: inline-block;
        }
    }
`;


const CloseButton = styled.a`
    width: 46px;
    height: 46px;
    background-color: ${Colours.BLUE};
    border-radius: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 300ms ease;
    cursor: pointer;
    position: absolute;
    top: -12px;
    right: -12px;
    z-index: 99999;

    :active {
        background-color: ${Colours.ORANGE};
    }
`;

const Close = styled(IoClose)`
    color: white;
    font-size: 32px;
`;

export async function getStaticProps(): Promise<GetStaticPropsResult<AboutProps>> {
    const employees = await sanity.getEmployees();
    return {
        props: {
            employees,
        },
        revalidate: 60,
    };
}
